import { find, map } from 'lodash/fp';

import { diversifiedHeroData, heroSectionData } from '../../data';
import { HOME_PAGE_BANNER_IDENTIFIERS } from '../../../../../../pages/utils/filter-home-page-banners';
import type { CmsBanner, HeroSectionProps } from '../../types';

type BannerProps = {
  heroSectionProps: HeroSectionProps;
  diversifiedHeroProps: HeroSectionProps;
};

const getBannerProps = (cmsBanners: CmsBanner[]): BannerProps => {
  const [cmsDefaultBannerContent, cmsDiversifiedBannerContent] = map(
    (identifier) => find((banner) => banner?.identifier?.current === identifier, cmsBanners),
    [HOME_PAGE_BANNER_IDENTIFIERS.DEFAULT, HOME_PAGE_BANNER_IDENTIFIERS.DIVERSIFIED],
  );
  return {
    diversifiedHeroProps: {
      ...diversifiedHeroData,
      ...cmsDiversifiedBannerContent,
    },
    heroSectionProps: {
      ...heroSectionData,
      ...cmsDefaultBannerContent,
    },
  };
};

export default getBannerProps;
